import { gql } from '@apollo/client';
import { BoxProps, Text } from '@chakra-ui/react';
import { DocumentNode } from 'graphql';
import * as React from 'react';

import { VoteCount_PollV2Fragment } from './graphql-types/VoteCount_PollV2Fragment';

export const VoteCount: React.FC<
  {
    poll: VoteCount_PollV2Fragment;
  } & BoxProps
> & {
  pollFragment: DocumentNode;
} = ({ poll, ...rest }) => {
  return (
    <Text textStyle="detail" color="gray.600" fontWeight="600" {...rest}>
      TOTAL VOTES: {poll.responseCount}
    </Text>
  );
};

VoteCount.pollFragment = gql`
  fragment VoteCount_PollV2Fragment on PollV2 {
    _id
    responseCount
  }
`;
